import React from 'react';
import { isFeatureEnabled } from '../config/featureFlags';

const EnvironmentBanner: React.FC = () => {
  // 只在開發環境顯示
  if (process.env.NODE_ENV === 'production' && !isFeatureEnabled('enableDebugMode')) {
    return null;
  }

  const isDevelopment = process.env.NODE_ENV === 'development' || isFeatureEnabled('enableDebugMode');
  
  if (!isDevelopment) {
    return null;
  }

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 text-white text-center py-2 px-4 shadow-lg"
      style={{ 
        background: 'linear-gradient(90deg, rgba(255, 107, 107, 0.2) 0%, rgba(255, 142, 83, 0.2) 100%)',
        boxShadow: '0 2px 10px rgba(255, 107, 107, 0.1)'
      }}
    >
      <div className="flex items-center justify-center space-x-2">
        <span className="text-sm font-semibold">🚧</span>
        <span className="text-sm font-semibold">開發環境 - 實驗性功能</span>
        <span className="text-xs opacity-90">(包含未發布的新功能)</span>
      </div>
    </div>
  );
};

export default EnvironmentBanner;
